/* import __COLOCATED_TEMPLATE__ from './card-icon.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();